import { Link } from 'react-router-dom';

export default function ArticleCtaSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 mb-3">
          Chcesz dowiedzieć się więcej?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-lg mx-auto">
          Przeczytaj nasz kompletny przewodnik po Kakobuy Spreadsheet. Dowiedz się jak zacząć,
          na co zwracać uwagę i jak maksymalnie wykorzystać możliwości platformy.
        </p>
        <Link
          to="/artykul/kakobuy-spreadsheet-przewodnik"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all duration-200"
        >
          Przeczytaj pełny przewodnik
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}